import React from "react";
//import LandingPage from "../components/LandingPage"
import ErrorsHistory from "../../components/ErrorsHistory";

const ErrorsHistoryScreen = () => {
  return <ErrorsHistory />;
};

export default ErrorsHistoryScreen;
